/*
 * Copyright (C) 2019 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import {
  BrowseSettings,
  BrowseSettingsRequest,
  DisplayConfigRequest,
  OrganizationImageUpdateRequest,
  OrganizationNameUpdateRequest,
} from '../../../../../shared/models';
import { ItemWithUploadUrl } from '../../../../../shared/models/ItemWithUploadUrl';
import { ObservableResult } from '../../../../../shared/store';
import { PlaylistAuthorDataService } from './data.service';

export class MockPlaylistAuthorDataService implements PlaylistAuthorDataService {
  updateVisibility(playlistUid: string, request: DisplayConfigRequest): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  updateOrganizationImage(playlistUid: string, request: OrganizationImageUpdateRequest): ObservableResult<ItemWithUploadUrl<void>> {
    return ObservableResult.ofSuccess();
  }

  updateOrganizationName(playlistUid: string, request: OrganizationNameUpdateRequest): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }

  setIsShared(playlistUid: string, allow: boolean): ObservableResult<boolean> {
    return ObservableResult.ofSuccess(allow);
  }

  updateBrowseSettings(playlistUid: string, request: BrowseSettingsRequest): ObservableResult<BrowseSettings> {
    return ObservableResult.ofSuccess({ ...request, updatedAt: new Date().toISOString() });
  }
}
